
<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#24292d;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
<v-dialog v-model="enviado" max-width="500px">
  <v-card>
    <v-card-title>Solicitud Exitosa</v-card-title>
    <v-card-text>
  <v-row>
    <v-col>
      <p>Se le enviará un correo electronico con la invitacion para esta fiesta.</p>
      <p>Asegurese de revisar en spam.</p>
    </v-col>
  </v-row></v-card-text></v-card>
</v-dialog>
        <v-row  justify="center">
          <v-col  cols="12" lg="12" md="12" sm="12">
            <v-card color="#2f363e">
              <v-card-title>
                <v-row>
                  <v-col cols="1">
                    <v-btn icon :top="top" :right="right" @click="$router.go(-1)">
                      <v-icon>far fa-times-circle</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="11">
                    <h1 class="text-center" style="font-size: xxx-large;"> {{acto.nombre}}</h1>

                  </v-col>
                </v-row>

              </v-card-title>
              <v-card-text><v-row align="top" justify="center" >

                <v-divider inset></v-divider>

                <v-col cols="12" sm="12" lg="12" md="12">
                  <h2  class="text-center"> {{organizador}}</h2>
                </v-col>

                <v-col cols="12" lg="4" sm="6" md="4">
                  <v-row>
                    <v-col v-if="act_instagram" cols="2">
                   <v-btn :href="instagram" target="_blank" icon rounded> <v-icon large >fab fa-instagram</v-icon></v-btn>
                    </v-col>
                    <v-col v-if="act_facebook" cols="2">
                      <v-btn :href="facebook" target="_blank" icon rounded> <v-icon large >fab fa-facebook</v-icon></v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-img v-if="foto=='sinimagen'"  contain  src="@/assets/no-image.jpeg"
                      ></v-img>
                      <v-img v-else  contain :src="foto"></v-img>
                    </v-col>
                  </v-row>


                </v-col>
                <v-col cols="12" lg="8" sm="12" md="8">
                  <v-row>
                    <v-col cols="12" sm="12" lg="12" md="12">
                      Hora de Inicio {{horaInicio}}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" lg="12" md="12">

                      <gmaps-map @mounted="ready" :options="options"
                                 style='width:100%;  height: 400px;'>
                        <gmaps-marker :position="options.position" :options="optionsMarker"  />
                      </gmaps-map>

                    </v-col>
                  </v-row>
                  <v-row v-if="freeapp">
                    <v-col cols="12" sm="12" lg="12" md="12">
                      <h1>Solicitar un QR para esta fiesta</h1>
                    </v-col>
                    <v-col cols="12" sm="12" lg="12" md="12">
                        <v-row>
                          <v-col>
                            <v-text-field v-model="qrNombre" label="Nombre" placeholder="Nombre"></v-text-field>
                          </v-col>
                          <v-col>
                            <v-text-field v-model="qrApellido" label="Apellido" placeholder="Apellido"></v-text-field>
                          </v-col>
                          <v-col>
                            <v-text-field v-model="qrEmail" label="Email" placeholder="Email"></v-text-field>
                          </v-col>
                          <v-col>
                            <v-btn @click="solicitar" >Solicitar</v-btn>
                          </v-col>
                        </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              </v-card-text>
            </v-card></v-col>
        </v-row>





      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";
import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import moment from "moment-timezone";
import store from "@/store";
import Cabecerabaja from "@/components/general/cabecerabaja";
import { gmaps, gmapsMap, gmapsMarker } from 'x5-gmaps';


export default {
  name: 'acto',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
    gmapsMap,
    gmapsMarker
  },
  data () {
    return {
      clientesimg: [],
      tag: '',
      acto:{} ,
      top:true,
      entradas:[],
      enviado:false,
      qrApellido:'',
      qrNombre:'',
      qrEmail:'',
      options:{
        position:{ lat: -12.0792903, lng: -77.004896 },
        center:{ lat: -12.0792903, lng: -77.004896 },
        zoom: 18
      },
      optionsMarker:{
        draggable:false
      },

      entradaseve:[],
      entradaevento:{},
      right:true,
      direction:'top',
      act_instagram:false,
      instagram:'',
      act_facebook:false,
      facebook:'',
      center: { lat: 45.508, lng: -73.587 },
      foto:'',
      freeapp:false,
      organizador:'',
      horaInicio:'',
      horaFinal:'',
      conectado:false,
      emailRules: [
        v => !!v || 'Se necesita el Email',
        v => /.+@.+/.test(v) || 'E-mail debe ser valido',
      ]
      ,
      headers: [
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Entrada', align: 'left',  value: 'eventoentrada.eventoEntrada'},
        { text: 'Precio', value: 'price' }
      ]
    }
  },
  mounted(){
    this.tag =  this.$route.params.id
    this.traeActo()

  },

  methods: {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("DD MMMM YYYY")
    },
    ready(map) {
      this.map = map
      gmaps().then((maps) => {
        this.places = new maps.places.PlacesService(map)
        this.autocomplete = new maps.places.Autocomplete(this.$refs.autocomplete)
        this.autocomplete.addListener('place_changed', this.update)
      })
    },
    solicitar(){
      let obj = {
        nombre: this.qrNombre,
        appaterno: this.qrApellido,
        email : this.qrEmail,
        actoId: this.acto.id
      }
      this.overlay = true
      axios
          .post('lista/fiesta/free',obj)
          .then((response)  => {
            console.log(response)
            this.enviado = true
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },
    traeActo(){
      this.overlay = true
      axios.get("actos/fiesta/"+this.tag)
          .then((response)  => {
            this.acto = response.data;
            store.dispatch("fetchEvento", response.data);
            this.overlay = false

            this.freeapp = this.acto.freeapp
            if(this.acto.foto === '' || this.acto.foto === null){

              if (this.acto.temporada === null ){
                if(this.acto.cliente === null){
                  this.foto='sinimagen'
                }else{
                  this.foto = this.acto.cliente.logo
                }
              }else{
                this.foto = this.acto.temporada.negocio.logo270
              }}else{
              this.foto = this.acto.foto
            }
            if (this.acto.temporada == null ){
              if(this.acto.cliente == null){
                this.organizador=''
              }else{
                this.organizador=this.acto.cliente.cliente
              }
              this.options.center = {
                lat: parseFloat(this.acto.lat),
                lng: parseFloat(this.acto.lng)
              }
              this.options.position = {
                lat: parseFloat(this.acto.lat),
                lng: parseFloat(this.acto.lng)
              }
              this.horaInicio = this.acto.horaInicio
              this.horaFinal = this.acto.horaFinal
            }else{
              this.organizador = this.acto.temporada.negocio.negocio
              this.horaInicio = this.acto.temporada.negocio.horaApertura
              this.horaFinal = this.acto.temporada.negocio.horaCierre
              if(this.acto.temporada.negocio.instagram.trim() !== ''){
                this.act_instagram = true
                this.instagram = this.acto.temporada.negocio.instagram;
              }
              if(this.acto.temporada.negocio.facebook.trim() !== ''){
                this.act_facebook = true
                this.instagram = this.acto.temporada.negocio.facebook;
              }
              this.options.center = {
                lat: parseFloat(this.acto.temporada.negocio.latitud),
                lng: parseFloat(this.acto.temporada.negocio.longitud)
              }

              this.options.position = {
                lat: parseFloat(this.acto.temporada.negocio.latitud),
                lng: parseFloat(this.acto.temporada.negocio.longitud)
              }
            }
          this.ready(this.map)

          })
          .catch((error)  => {
            console.log(error);
          });
    },

    comparaFechas(item){
      let fecIni = new Date(item.eventoentrada.fechaInicio + " 00:00:00");
      let fecFin = new Date(item.eventoentrada.fechaFin + " 00:00:00");
      let datenow = new Date();
      if( datenow >= fecIni && datenow<= fecFin){
        return true
      }else{
        return false
      }
    }

  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      evento: "evento"
    }),
    compareDates: function() {
      return (item) => this.comparaFechas(item);
    }
  }
}
</script>
